export const Insurance = {
  displayName: 'Insurance',
  serviceRoute: 'insurance'
};

export const serviceContextKey = 'lsng.service_context';
export const Origination = { displayName: 'Origination', serviceRoute: 'origination' };

export const getContextName = serviceName => {
  const serviceNameLowerCase = serviceName.toLowerCase();
  if (serviceNameLowerCase.includes('admin')) return Origination.displayName;
  if (serviceNameLowerCase.includes('insurance')) return Insurance.displayName;
  return 'N/A';
};

export const getServiceRoute = serviceName => {
  const serviceNameLowerCase = serviceName.toLowerCase();
  if (serviceNameLowerCase.includes('admin')) return Origination.serviceRoute;
  if (serviceNameLowerCase.includes('insurance')) return Insurance.serviceRoute;
  return 'N/A';
};
export const getContexts = () => [Insurance, Origination];
